import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import axois from "../../../../configs/axois";
import baseURL from "../../../../configs/api";
import { useTheme } from "../../../../components/hooks/useTheme";
import useDelete from "../../../../components/hooks/useDelete";
import PleaseWaitPopup from "../../../PleaseWaitPopup";
import colorConfigs from "../../../../configs/colorConfigs";
import useAuth from "../../../../components/hooks/useAuth";
import Cookies from "js-cookie";
import useTenant from "../../../../components/hooks/useTenant";

export const EditVehicleMake = () => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { auth }: any = useAuth();
  const { handleTenantError }: any = useTenant();
  const idNumber = useLocation();
  const { themeStyles } = useTheme();
  const navigate = useNavigate();
  const { setDeletePopup, setData: setDeleteData }: any = useDelete();
  const [label, setLabel] = useState<string>("");
  const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
  const [disabled, setDisabled] = useState<boolean>(true);

  useEffect(() => {
    axois
      .get(`${baseURL}vehicleMake/${idNumber?.state}`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setLabel(response?.data?.makeName);
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setPleaseWaitPopup(true);

    await axios
      .put(
        `${baseURL}vehicleMake?userId=${auth?.id}`,
        JSON.stringify({
          id: idNumber?.state,
          makeName: label,
        }),
        {
          headers: { 
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
           },
          withCredentials: true,
        }
      )
      .then(() => {
        setPleaseWaitPopup(false);
        navigate(-1);

        handleTenantError(null);
      })
      .catch((error) => {
        setPleaseWaitPopup(false);
        handleTenantError(error);
      });
  };

  const deleteVehicleMake = () => {
    setDeleteData({
      id: idNumber,
      tilte: `Delete`,
      summary: `Are you sure you want to delete this Vehicle Make?`,
      isDelete: (callback: any) => {
        setPleaseWaitPopup(true);

        fetch(`${baseURL}vehicleMake?id=${idNumber?.state}&userId=${auth?.id}`, {
          method: 'DELETE',
          headers: {
            'X-Tenant-ID': tenantId,
          }
        })
          .then(() => {
            setPleaseWaitPopup(false);
            navigate(-1);
            handleTenantError(null);
          })
          .catch((error) => {
            setPleaseWaitPopup(false);
            handleTenantError(error);
          });

        callback();
      }
    });

    setDeletePopup(true);
  };

  return (
    <>
      <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
        <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
          <div className="w-full mt-2">
            <div className={`w-full pb-4`}>
              <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                <div className="flex items-center gap-1.5">
                  <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Edit Vehicle Make</h2>
                </div>

                {
                  disabled && (
                    <button className={`px-[8px] py-[6px] bg-transparent shadow-sm rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                      onClick={() => setDisabled(false)}
                    >
                      <span className={`material-symbols-outlined text-[25px] font-light ${themeStyles.main.textSubHeadingColor}`}>
                        edit
                      </span>
                      <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>Edit</span>
                    </button>
                  )
                }
              </div>

              <div className="mt-2 p-2">
                <form onSubmit={(e) => handleSubmit(e)}>
                  <div className="w-full px-2">
                    <div className="grid grid-cols-3 gap-6">
                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Make</label>
                          <input
                            type="text"
                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={label}
                            disabled={disabled}
                            onChange={(e) => setLabel(e.target.value)}
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="flex gap-4 mt-6">
                      {
                        !disabled && (
                          <Button variant="contained"
                            sx={{
                              backgroundColor: colorConfigs.btn.main.bg
                            }}
                            type="submit">
                            Save
                          </Button>
                        )
                      }

                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.cancel.bg,
                          border: colorConfigs.btn.cancel.border,
                          color: colorConfigs.btn.cancel.color
                        }}
                        onClick={() => navigate(-1)}
                      >
                        Cancel
                      </Button>

                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.delete.bg,
                        }}
                        onClick={deleteVehicleMake}
                      >
                        Delete
                      </Button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
    </>
  )
};